"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.propsToAvailableProps = exports.placeAvailable = void 0;
var React = require("react");
var classnames_1 = require("classnames");
var PlaceState_1 = require("@/pages/place/states/PlaceState");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var format_1 = require("@/utils/format");
var PlaceResultListItems_1 = require("@/pages/place/components/PlaceResultListItems");
var propsToAvailableProps = function (props, filterType) { return ({
    filterType: filterType,
    t: props.t,
    availableShowBuildingName: props.availableShowBuildingName,
    currentSort: filterType === SfilterTypeGroup_1.SfilterType.RENT ? props.availableRentSort : props.availableSaleSort,
    currentOrder: filterType === SfilterTypeGroup_1.SfilterType.RENT ? props.availableRentOrder : props.availableSaleOrder,
    priceSortField: filterType === SfilterTypeGroup_1.SfilterType.RENT ? PlaceState_1.AvailableSortType.LEASE_PRICE : PlaceState_1.AvailableSortType.SALE_PRICE,
    // tslint:disable-next-line: max-line-length
    ppsfSortField: filterType === SfilterTypeGroup_1.SfilterType.RENT ? PlaceState_1.AvailableSortType.LEASE_PRICE_PER_SQFT : PlaceState_1.AvailableSortType.SALE_PRICE_PER_SQFT,
    currencyCode: props.currencyCode,
    showFollow: props.isDemolished,
    followId: props.saveSearchId,
    followName: props.nameMain,
    results: filterType === SfilterTypeGroup_1.SfilterType.RENT ? props.availablePropertiesRent : props.availablePropertiesSale,
    lang: props.lang,
    textImages: props.textImages,
    district: props.district,
    districtRentLink: props.viewRentLinkOfDistrict,
    districtSaleLink: props.viewSaleLinkOfDistrict,
}); };
exports.propsToAvailableProps = propsToAvailableProps;
var placeAvailableFc = function (props) {
    if (!props.availablePropertiesRent.length &&
        !props.availablePropertiesSale.length) {
        var renderEmpty = function (props) {
            var getTitle = function (type, textImages) {
                if (textImages && textImages.emptyTitleBuyRent) {
                    return React.createElement("img", { src: textImages.emptyTitleBuyRent });
                }
                if (textImages && textImages.emptyTitle) {
                    return React.createElement("img", { src: textImages.emptyTitle });
                }
                return props.t.noAvailableListingTitle;
            };
            var getCaption = function (type, textImages) {
                if (type === SfilterTypeGroup_1.SfilterType.BUY) {
                    if (textImages && textImages.emptyCaptionBuy) {
                        return React.createElement("img", { src: textImages.emptyCaptionBuy });
                    }
                    return props.t.noAvailableListingCaptionBuy;
                }
                if (type === SfilterTypeGroup_1.SfilterType.RENT) {
                    if (textImages && textImages.emptyCaptionRent) {
                        return React.createElement("img", { src: textImages.emptyCaptionRent });
                    }
                    return props.t.noAvailableListingCaptionRent;
                }
                if (textImages && textImages.emptyCaption) {
                    return React.createElement("img", { src: textImages.emptyCaption });
                }
                return props.t.noAvailableListingCaption;
            };
            var title = getTitle(props.filterType, props.textImages);
            var caption = getCaption(props.filterType, props.textImages);
            return (React.createElement("div", { className: "c-jumbo c-jumbo__column c-jumbo--lift", style: { marginTop: '20px' } },
                React.createElement("div", { className: "c-jumbo__img" },
                    React.createElement("img", { src: "/res/img/404.jpg" })),
                React.createElement("div", { className: "c-jumbo__main" },
                    React.createElement("div", { className: "c-jumbo__header" },
                        React.createElement("div", { className: "c-jumbo__header-main" },
                            React.createElement("div", { className: "c-jumbo__title" }, title),
                            React.createElement("div", { className: "c-jumbo__caption" }, caption))),
                    React.createElement("div", { className: "c-jumbo__body" },
                        React.createElement("div", { className: "c-jumbo__content" },
                            React.createElement("div", { className: "c-jumbo__content-row" }, props.t.noAvailableListingBody)),
                        React.createElement("div", { className: "c-jumbo__actions" },
                            React.createElement("a", { href: props.districtRentLink, className: "o-btn u-upper o-btn--primary" },
                                React.createElement("span", { className: "fal fa-search" }),
                                "\u00A0",
                                format_1.default.print(props.t.searchMoreListingForRent, [props.district])),
                            React.createElement("a", { href: props.districtSaleLink, className: "o-btn u-upper o-btn--primary" },
                                React.createElement("span", { className: "fal fa-search" }),
                                "\u00A0",
                                format_1.default.print(props.t.searchMoreListingForSale, [props.district])))))));
        };
        return (React.createElement("div", { className: "l-container l-container--lr" },
            React.createElement("div", { className: "l-container__main" },
                React.createElement("div", { className: "l-pad l-pad--4" },
                    React.createElement("div", { id: "place-list-both" }, renderEmpty(propsToAvailableProps(props)))))));
    }
    // Check if we have sale or rent properties
    var hasSaleProperties = props.availablePropertiesSale && props.availablePropertiesSale.length > 0;
    var hasRentProperties = props.availablePropertiesRent && props.availablePropertiesRent.length > 0;
    // State for managing active tab
    var _a = React.useState(hasSaleProperties ? 'sale' : 'rent'), activeListingTab = _a[0], setActiveListingTab = _a[1];
    var tableViewRentOrderClass = classnames_1.default([
        'c-tableview',
        'c-tableview--extra',
        {
            'c-tableview--asc': props.availableRentOrder === PlaceState_1.AvailableSortOrder.ASC,
        },
    ]);
    var tableViewSaleOrderClass = classnames_1.default([
        'c-tableview',
        'c-tableview--extra',
        {
            'c-tableview--asc': props.availableSaleOrder === PlaceState_1.AvailableSortOrder.ASC,
        },
    ]);
    var renderRentMore = function (props) {
        if (!props.availablePropertiesRent.length)
            return null;
        var hasMore = props.availablePropertiesRent.length < props.forRentCount;
        var moreText = hasMore ? props.t.viewOnSearch :
            format_1.default.print(props.t.viewMoreListingForRentInDistrict, [props.district]);
        var link = hasMore ? props.viewRentLink : props.viewRentLinkOfDistrict;
        return (React.createElement("div", { className: "l-pad--4 u-text-center" },
            React.createElement("a", { rel: "nofollow", href: link, className: "o-btn o-btn--primary" },
                React.createElement("span", { className: "fa fa-search" }),
                " \u00A0",
                moreText)));
    };
    var renderBuyMore = function (props) {
        if (!props.availablePropertiesSale.length)
            return null;
        var hasMore = props.availablePropertiesSale.length < props.forSaleCount;
        var moreText = hasMore ? props.t.viewOnSearch :
            format_1.default.print(props.t.viewMoreListingForSaleInDistrict, [props.district]);
        var link = hasMore ? props.viewSaleLink : props.viewSaleLinkOfDistrict;
        return (React.createElement("div", { className: "l-pad--4 u-text-center" },
            React.createElement("a", { rel: "nofollow", href: link, className: "o-btn o-btn--primary" },
                React.createElement("span", { className: "fa fa-search" }),
                " \u00A0",
                moreText)));
    };
    var renderRentList = function (props) {
        var placeAvailableProps = propsToAvailableProps(props, SfilterTypeGroup_1.SfilterType.RENT);
        if (!placeAvailableProps.results.length)
            return null;
        var renderRentMedian = function (props) {
            return props.forRentCount ? (React.createElement("div", { className: "c-detailsearch__item" },
                React.createElement("div", { className: "c-detailsearch__row" },
                    React.createElement("div", { className: "c-detailsearch__cell" },
                        React.createElement("div", { className: "c-detailsearch__title" },
                            React.createElement("span", { className: "fal fa-tag" }),
                            React.createElement("span", null,
                                props.t.forRent,
                                " :"),
                            React.createElement("span", { className: "c-detailsearch__big" }, props.forRentCount ? props.forRentCount : 'N/A')))),
                props.medianLeasePrice ? renderMedianLease(props) : '')) : ('');
        };
        return (React.createElement(React.Fragment, null,
            placeAvailableProps.results.length ? renderRentMedian(props) : null,
            React.createElement(PlaceResultListItems_1.default, __assign({}, placeAvailableProps, { symbol: props.symbol, googleApikey: props.googleApikey }))));
    };
    var renderBuyList = function (props) {
        var placeAvailableProps = propsToAvailableProps(props, SfilterTypeGroup_1.SfilterType.BUY);
        if (!placeAvailableProps.results.length)
            return null;
        var renderSaleMedian = function (props) {
            return props.forSaleCount ? (React.createElement("div", { className: "c-detailsearch__item" },
                React.createElement("div", { className: "c-detailsearch__row" },
                    React.createElement("div", { className: "c-detailsearch__cell" },
                        React.createElement("div", { className: "c-detailsearch__title" },
                            React.createElement("span", { className: "fal fa-tag" }),
                            React.createElement("span", null,
                                props.t.forSale,
                                " :"),
                            React.createElement("span", { className: "c-detailsearch__big" }, props.forSaleCount ? props.forSaleCount : 'N/A')))),
                props.medianSalePpsf ? renderMedianSalePpsf(props) : '')) : ('');
        };
        return (React.createElement(React.Fragment, null,
            placeAvailableProps.results.length ? renderSaleMedian(props) : null,
            React.createElement(PlaceResultListItems_1.default, __assign({}, placeAvailableProps, { symbol: props.symbol, googleApikey: props.googleApikey }))));
    };
    var renderMedianSalePpsf = function (props) {
        return (React.createElement("div", { className: "c-detailsearch__row" },
            React.createElement("div", { className: "c-detailsearch__cell" },
                React.createElement("div", { className: "c-detailsearch__title" },
                    React.createElement("span", { className: "fal fa-chart-line" }),
                    React.createElement("span", null,
                        props.t.median,
                        " :"),
                    React.createElement("span", null,
                        React.createElement("span", { className: "c-detailsearch__big" }, format_1.default.currencyPpsf(props.medianSalePpsf, props.symbol)),
                        React.createElement("span", { className: "c-detailsearch__sm" }, props.t.ppsf))))));
    };
    var renderMedianLease = function (props) {
        return (React.createElement("div", { className: "c-detailsearch__row" },
            React.createElement("div", { className: "c-detailsearch__cell" },
                React.createElement("div", { className: "c-detailsearch__title" },
                    React.createElement("span", { className: "fal fa-chart-line" }),
                    React.createElement("span", null,
                        props.t.median,
                        " :"),
                    React.createElement("span", null,
                        React.createElement("span", { className: "c-detailsearch__big" }, format_1.default.currencyDetailLease(props.medianLeasePrice, props.lang, props.symbol)))))));
    };
    var renderTabButton = function (tabType, label, isAvailable) {
        if (!isAvailable)
            return null;
        var tabClass = classnames_1.default([
            'okay-tabs-btn',
            { 'okay-tabs-btn--active': activeListingTab === tabType }
        ]);
        return (React.createElement("a", { key: tabType, onClick: function () { return setActiveListingTab(tabType); }, className: tabClass }, label));
    };
    var renderActiveContent = function () {
        var currentOrderClass = activeListingTab === 'sale' ? tableViewSaleOrderClass : tableViewRentOrderClass;
        if (activeListingTab === 'sale' && hasSaleProperties) {
            return (React.createElement("div", { className: currentOrderClass, style: { paddingTop: '20px' } }, renderBuyList(props)));
        }
        else if (activeListingTab === 'rent' && hasRentProperties) {
            return (React.createElement("div", { className: currentOrderClass, style: { paddingTop: '20px' } }, renderRentList(props)));
        }
        return null;
    };
    return (React.createElement("div", { id: "place-listing", style: { marginBottom: '20px' } },
        React.createElement("div", { className: "l-container l-container--lr" },
            React.createElement("div", { className: "l-container__main" },
                React.createElement("div", { className: "l-pad l-pad--4" },
                    React.createElement("div", { className: "c-place__listing-tabs" },
                        React.createElement("h2", null,
                            props.nameMain,
                            " - ",
                            props.t.availableListings),
                        React.createElement("div", { className: "okay-tabs" },
                            renderTabButton('sale', props.t.forSale, hasSaleProperties),
                            renderTabButton('rent', props.t.forRent, hasRentProperties))),
                    renderActiveContent())))));
};
var placeAvailable = function (props) {
    React.useEffect(function () {
        props.onSortUpdateCompleted();
    });
    return placeAvailableFc(props);
};
exports.placeAvailable = placeAvailable;
